<template>
  <div class="zbo-baic-intro-card">
    <h2 class="zbo-baic-intro-card__title-text">{{ $t('billing.zuoraoutage.zoom_workplace_basic_title') }}</h2>
    <p class="zbo-baic-intro-card__desc-text">
      <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
      {{ $t('billing.zuoraoutage.zoom_workplace_basic_introduction_1', [getFreeUserMeetingMinutes()]) }}
    </p>
    <p class="zbo-baic-intro-card__desc-text">
      <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
      {{ $t('billing.zuoraoutage.zoom_workplace_basic_introduction_2') }}
    </p>
    <p class="zbo-baic-intro-card__desc-text">
      <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
      {{ $t('billing.zuoraoutage.zoom_workplace_basic_introduction_3') }}
    </p>
    <p class="zbo-baic-intro-card__desc-text">
      <img src="@/assets/plans/checked_checkboxes-green.svg" alt="Include" />
      {{ $t('billing.zuoraoutage.zoom_workplace_basic_introduction_4') }}
    </p>
  </div>
</template>
<script>
import { getFreeUserMeetingMinutes } from '@/utils/meeting';

export default {
  name: 'zoom-basic-intro-card',
  methods: { getFreeUserMeetingMinutes },
};
</script>

<style lang="scss" scoped>
.zbo-baic-intro-card {
  position: relative;
  margin-top: 64px;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.12);
  &::before {
    position: absolute;
    top: -32px;
    left: 0;
    content: ' ';
    width: 100%;
    height: 32px;
    border-top: 1px solid #dfe3e8;
  }
  &__title-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    color: #0b5cff;
    margin-bottom: 22px;
  }
  &__desc-text {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 8px 0;
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
}
</style>
